import { notifySessionExpired } from "./session";
import { getToken } from "./auth";

export const API_BASE =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_BASE) ||
  process.env.REACT_APP_API_BASE ||
  "http://localhost:8000";

export function buildURL(base, path, params = {}) {
  const url = new URL(path, base);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") {
      url.searchParams.set(k, String(v));
    }
  });
  url.searchParams.set("_ts", Date.now());
  return url.toString();
}

export async function requestJSON(url, options = {}) {
  const res = await fetch(url, {
    credentials: "same-origin",
    cache: "no-store",
    ...options,
    headers: {
      Accept: "application/json, text/plain, */*",
      ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
      ...(options.headers || {}),
    },
  });

  const text = await res.text().catch(() => "");
  const contentType = res.headers.get("content-type") || "";
  const isJSON = contentType.includes("application/json");
  const statusMessage = `HTTP ${res.status}`;

  if (!res.ok) {
    let errorMessage = text || statusMessage;
    if (isJSON) {
      try {
        const parsed = JSON.parse(text || "{}");
        errorMessage = parsed?.detail || parsed?.message || JSON.stringify(parsed) || errorMessage;
      } catch {
        // fallthrough
      }
    }
    if ([401, 403].includes(res.status)) {
      const sessionMsg = "다시 로그인하세요.";
      notifySessionExpired(sessionMsg);
      errorMessage = sessionMsg;
    }
    throw new Error(errorMessage);
  }

  if (!text) return {};
  if (isJSON) {
    try {
      return JSON.parse(text);
    } catch (error) {
      throw new Error(`Invalid JSON: ${String(error)}\n${text.slice(0, 200)}`);
    }
  }
  return text;
}
